import VendasCupomItemService from "@/services/VendasCupomItemService";

export const vendasCupomItem = {
  namespaced: true,
  state: {
    vendasCupomItem: {},
  },
  actions: {
    putVendasCupomItemEdicao({ commit }, payload) {
      return VendasCupomItemService.PutVendasCupomItemEdicao(payload).then(
        (vendasCupomItem) => {
          return Promise.resolve(vendasCupomItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendasCupomItemOData({ commit }, payload) {
      return VendasCupomItemService.GetVendasCupomItemOData(payload).then(
        (vendasCupomItem) => {
          return Promise.resolve(vendasCupomItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default vendasCupomItem;
